import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './firebase';

const IMAGE_TRAILS_COLLECTION = 'imageTrails';

export const imageTrailsService = {
  async getAllImageTrails() {
    const querySnapshot = await getDocs(collection(db, IMAGE_TRAILS_COLLECTION));
    return querySnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  },

  async addImageTrail({ name, imageUrl, skill, ctaHeading, ctaSubtext }) {
    const docRef = await addDoc(collection(db, IMAGE_TRAILS_COLLECTION), {
      name,
      imageUrl,
      skill: skill || null,
      ctaHeading: ctaHeading || null,
      ctaSubtext: ctaSubtext || null,
      createdAt: serverTimestamp()
    });
    return docRef.id;
  },

  async updateImageTrail(id, { name, imageUrl, skill, ctaHeading, ctaSubtext }) {
    await updateDoc(doc(db, IMAGE_TRAILS_COLLECTION, id), {
      name,
      imageUrl,
      skill: skill || null,
      ctaHeading: ctaHeading || null,
      ctaSubtext: ctaSubtext || null,
    });
  },

  async deleteImageTrail(id) {
    await deleteDoc(doc(db, IMAGE_TRAILS_COLLECTION, id));
  }
};
